import permission from './permission.en';
import profileForm from './profile-form.en';
import projectProfile from './project-profile.en';
import viewer3dProfile from './viewer-3d-profile.en';
export default {
    permission,
    profileForm,
    projectProfile,
    viewer3dProfile,
};
